import CryptoJS from 'crypto-js';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// export const BACKENDURL = 'http://127.0.0.1:8084/api';
//  export const BACKENDURLFiles = 'http://127.0.0.1:8084/storage/';
const protocol = window.location.protocol;

// Set the backend URLs based on the protocol
export const BACKENDURL = `${protocol}//back.emmanuelshops.co.tz/api`;
export const BACKENDURLFiles = `${protocol}//back.emmanuelshops.co.tz/storage/`;


const SECRET_KEY = 'eeff102d5555b2ea60786a38f9ca1a97540cbea6c7ddbb2fbc905db4af1baff2'; // Use a secure, environment-specific secret key

// Encrypt and store data
export const saveUserData = (user) => {
  const limitedUser = {
    user: user,
  };
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(limitedUser), SECRET_KEY).toString();
  localStorage.setItem('user', encryptedData);
};

// Decrypt and retrieve data
export const getUserData = () => {
  const encryptedData = localStorage.getItem('user');
  if (!encryptedData) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (e) {
    console.error('Error decrypting user data', e);
    return null;
  }
};

// Clear stored data
export const clearUserData = () => {
  localStorage.removeItem('user');
};

export const shopId = localStorage.getItem('shopId');
export const employeeId = localStorage.getItem('employeeId');






dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Convert, format, and handle dates consistently.
 * 
 * @param {string | Date} date - The date to process.
 * @param {string} targetTimeZone - The time zone to convert to (default: UTC).
 * @param {string} format - The desired date format (default: 'YYYY-MM-DD HH:mm:ss').
 * @returns {string} The formatted date string.
 */
export const processDate = (date, targetTimeZone = "UTC", format = "YYYY-MM-DD HH:mm:ss") => {
  return dayjs.utc(date).tz(targetTimeZone).format(format);
};


export const getPermission = () => {
  const userData = getUserData();
  const shopId = Number(localStorage.getItem('shopId')); // Retrieve and convert shopId to a number

  // Filter permissions by shopId and return the first match
  return userData?.user?.user_permissions?.find(permission => permission.shop_id === shopId) || {};
};



